import script from "./ProjectNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ProjectNavigation.vue?vue&type=style&index=0&id=5aa6fef5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa6fef5"]])

export default __exports__